import { SortingMode } from '@griply/types';

// Guards against corrupt/legacy sortingMode values persisted on a filter
// document: anything that is not a current SortingMode member collapses to
// undefined so both apps feed the tree builders identical input.
export const normalizeSortingMode = (
  sortingMode: SortingMode | null | undefined,
): SortingMode | undefined =>
  sortingMode && (Object.values(SortingMode) as string[]).includes(sortingMode)
    ? sortingMode
    : undefined;
